<template>
  <div id="app">
    <component :is="$route.meta.layout || 'div'">
      <router-view></router-view>
    </component>
    <loading v-if="$store.getters.getIsLoadingOn" />
    <loginAlertPopup v-if="this.$store.state.loginModal === true" @loginModalUpdate="updateloginModal"/>
  </div>
</template>

<script>
import loading from '@/components/elements/LoadingPage.vue'
import loginAlertPopup from "@/views/home/LoginAlertPopup";
import store from "@/store";
export default {
  components: {
    loading,
    loginAlertPopup
  },
  data() {
    return {
      loginModal: false,
    }
  },
  mounted() {
    this.isAppCheck();
    this.googleGtm();
  },
  methods: {
    updateloginModal(loginModalFlag){
      store.commit("loginAlertPopup", loginModalFlag);

      if(!loginModalFlag) {
        const bodyHtml = document.body;
        bodyHtml.style.overflow = 'auto'
        if(this.$router.currentRoute.path != "/home") {
          this.$router.replace("/home");
        }
      }
    },
    isAppCheck() {
      const varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

      if ( varUA.indexOf('android') > -1
          && this.$router.currentRoute.path != '/mobile'
          && this.$router.currentRoute.path != '/emarticon/emarticonQuestionsWeb'
          && window.location.pathname != '/award/emarticonAwardHome'
          && window.location.pathname != '/award/awardCode') {
        // window.location.href = "emart-today://goback/?enable=N" // 뒤로가기 미허용
        if(this.$router.currentRoute.path == '/product/order-result' && this.isAwaradLogin()) { //시상용 결제 완료 네이티브 호출 제외
          return;
        } else {
          window.location.href = "emart-today://scroll_control/?isRefresh=N" //새로고침 막기
        }
      }
    },
    googleGtm() { //구글 GTM

      //GTM-W8BX5F6 prod
      //GTM-5THW4B6 stg
      //GTM-KMBJCSW dev

      const gtmKey = process.env.VUE_APP_GTM_KEY;

      let gtmScript = document.createElement('script');
      let gtmScriptFunction = document.createTextNode(
          "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':"+
          "new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],"+
          "j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src="+
          "'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);"+
          "})(window,document,'script','dataLayer','" +
          gtmKey +
          "');"
      );

      gtmScript.appendChild(gtmScriptFunction);
      document.head.appendChild(gtmScript);

      let gtmNoScript = document.createElement('noscript');
      let gtmIframe = document.createElement('iframe');
      gtmIframe.setAttribute('src', 'https://www.googletagmanager.com/ns.html?id='+gtmKey+'');
      gtmIframe.style.height = '0';
      gtmIframe.style.width = '0';
      gtmIframe.style.display = 'none'
      gtmIframe.style.visibility = 'hidden'
      gtmNoScript.appendChild(gtmIframe);
      document.body.appendChild(gtmNoScript)
    },
    /**
     * 시상용 로그인 체크
     */
    isAwaradLogin() {
      if(this.$store.state.mberInfo.mberNo && this.$store.state.mberInfo.mberNo.substring(0,1) != 'C') {
        return true;
      } else {
        return false;
      }
    }
  }

}
</script>

<style lang="scss">
  body { padding :0px; margin: 0px; }
  @import '@/assets/styles/common.scss';
  @import '@/assets/styles/rem.scss';
</style>
